export default [
  {
    id: 4,
    name: 'Pågatågen'
  },
  {
    id: 5,
    name: 'Östgötapendeln'
  },
  {
    id: 17,
    name: 'Tåg i Bergslagen'
  },
  {
    id: 19,
    name: 'X-Trafik'
  },
  {
    id: 21,
    name: 'Norrtåg'
  },
  {
    id: 22,
    name: 'Öresundståg'
  }
]
